import { render, staticRenderFns } from "./NotesOnAdmin.vue?vue&type=template&id=d1d5bd9c&scoped=true"
import script from "./NotesOnAdmin.vue?vue&type=script&lang=js"
export * from "./NotesOnAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d5bd9c",
  null
  
)

export default component.exports